import { IconBg } from '@/components/ui/IconBg'
import { ApplicationIcon, OrganisationIcon, ProjectIcon } from '@/const'
import { useCurrentWorkspace } from './useCurrentWorkspace'

export function WorkspaceDetailsBanner() {
  const workspace = useCurrentWorkspace()
  const { organisation, project, application } = workspace
  return (
    // <div className="flex shrink-0 flex-row flex-wrap gap-x-20 gap-y-4 rounded-2xl bg-background p-6 shadow">
    <div className="flex shrink-0 flex-row flex-wrap gap-x-20 gap-y-4 bg-background p-6 shadow">
      {[
        { label: 'Organisation', value: organisation, Icon: OrganisationIcon },
        { label: 'Project', value: project, Icon: ProjectIcon },
        { label: 'Application', value: application, Icon: ApplicationIcon },
      ].map(({ label, value, Icon }) => (
        <div key={label} className="flex items-center gap-3">
          <IconBg tooltip={label} className="size-12">
            <Icon className="size-5 text-muted-foreground" />
          </IconBg>
          <div className="flex flex-col whitespace-nowrap">
            <span className="text-sm font-light italic">{label}:</span>
            <span className="text-base">{value}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
